<template>
<div>
<template v-if="item.files.length > 0">
<div class="document">
<div class="item">
<a :href="this.selectedUrl" target="_blank"
><strong class="doc-title" v-html="item.post_title"></strong
></a>
<br />
<div class="d-flex justify-content-start" style="gap: 6px;">
<div class="select-overlay-container m-0" style="cursor: pointer;">
<select
                v-if="versionValueExists(item.files, 'version')"
                v-model="selectedVersion"
                @change="handleVersionChange"
                style="vertical-align: super;padding:4px;border-radius:20px;margin-right:5px;min-width:100px;max-width:100px"
                :disabled="filteredVersion.length === 1"
>
<option
                  v-for="version in filteredVersion"
                  :value="version"
                  :text="version"
>{{ version }}</option
>
</select>
<select
                v-model="selectedOption"
                @change="handleLanguageChange"
                style="vertical-align: super;padding:4px;border-radius:20px;min-width:100px;max-width:100px"
                :disabled="filteredLanguages.length === 1"
>
<option
                  v-for="lang in filteredLanguages"
                  :value="lang"
                  :text="lang"
>{{ lang }}</option
>
</select>
 
              <a :href="this.selectedUrl" target="_blank" @click="onDownloadClick">
<img src="@/assets/images/download_icon_black.png" alt="" style="display:inline;padding-left:8px;height:26px">
</a>
</div>
</div>
</div>
<div class="resource-center mt-5" v-if="item.cta.href">
<div
            :href="item.cta.href"
            :target="item.cta.target"
            class="btn cta-pill filled-red icon right-arrow"
>
            {{ item.cta.text }}
</div>
</div>
</div>
</template>
 
    <template v-else>
<a :href="item.files[0].file" target="_blank">
<div class="document">
<div class="item">
<strong class="doc-title" v-html="item.post_title"></strong>
<br />
<a
              :href="item.files[0].file"
              target="_blank"
              class="btn cta-plain text-red icon right-arrow"
              @click="onFallbackDownloadClick"
>{{ item.cta }}</a
>
</div>
</div></a
>
</template>
</div>
</template>
 
<script>
import { track_file_download } from "../../../../analytics/events";
 
export default {
  props: ["item"],
  data() {
    return {
      active: false,
      selectedOption: this.item.files[0].language,
      selectedUrl: this.item.files[0].file,
      selectedVersion: this.item.files[0].version,
    };
  },
  watch: {
    active(v) {
      bus.$emit("slick-slider:slide-height-changed");
    },
  },
  computed: {
    filteredVersion() {
      const uniqueVersion = new Set();
      var allVersion = this.item.files;
      allVersion.forEach((element) => {
        uniqueVersion.add(element.version);
      });
      return Array.from(uniqueVersion);
    },
    filteredLanguages() {
      const uniqueLanguage = new Set();
      var variousLanugages = this.selectedVersion
        ? this.item.files.filter((x) => x.version === this.selectedVersion)
        : this.item.files;
      var allLanugages = this.item.files;
      for (var n = 0; n < allLanugages.length; n++) {
        var element = allLanugages[n];
        element.unique =
          element.language + (element.version ? "_" + element.version : "");
        if (variousLanugages.includes(element))
          uniqueLanguage.add(element.language);
      }
      return Array.from(uniqueLanguage);
    },
    // Currently selected file object for rich tracking data
    selectedFileObject() {
      return (
        this.item.files.find((f) => f.file === this.selectedUrl) ||
        this.item.files[0]
      );
    },
  },
  methods: {
    // ── Analytics helpers ──────────────────────────────────────────
    onDownloadClick() {
      const file = this.selectedFileObject;
      track_file_download({
        clicked_area: "search-results",
        component_name: "search-result-type-document",
        component_variant: "document",
        pdf_name: this.item.post_title,
        file_title: this.item.post_title,
        file_url: this.selectedUrl,
        clickURL: this.selectedUrl,
        file_language: file ? file.language : this.selectedOption,
        file_format: this.selectedUrl ? this.selectedUrl.split(".").pop() : "",
        file_type: "document",
      });
    },
    onFallbackDownloadClick() {
      const file = this.item.files[0];
      track_file_download({
        clicked_area: "search-results",
        component_name: "search-result-type-document",
        component_variant: "document-fallback",
        pdf_name: this.item.post_title,
        file_title: this.item.post_title,
        file_url: file.file,
        clickURL: file.file,
        file_language: file.language,
        file_format: file.file ? file.file.split(".").pop() : "",
        file_type: "document",
      });
    },
    // ── Existing methods ───────────────────────────────────────────
    handleLanguageChange(event) {
      var uniqueId =
        event.target.value +
        (this.selectedVersion ? "_" + this.selectedVersion : "");
      var filteredFile = this.item.files.filter(
        (x) => x.unique === uniqueId
      )[0];
      if (filteredFile) {
        this.selectedUrl = filteredFile.file;
        this.selectedVersion = filteredFile.version;
      } else {
        filteredFile = this.item.files.filter(
          (x) => x.language === event.target.value
        )[0];
        this.selectedVersion = filteredFile.version;
        this.selectedUrl = filteredFile.file;
      }
    },
    handleVersionChange(event) {
      this.selectedOption = this.item.files.filter(
        (x) => x.version === event.target.value
      )[0].language;
 
      var uniqueId = this.selectedOption + "_" + event.target.value;
      var filteredFile = this.item.files.filter(
        (x) => x.unique === uniqueId
      )[0];
      if (filteredFile) {
        this.selectedUrl = filteredFile.file;
        this.selectedOption = filteredFile.language;
      } else {
        filteredFile = this.item.files.filter(
          (x) => x.version === event.target.value
        )[0];
        this.selectedOption = filteredFile.language;
        this.selectedUrl = filteredFile.file;
      }
    },
    versionValueExists(jsonData, attributeName) {
      var result = jsonData.filter((x) => x.version && x.version !== "");
      return result.length > 0;
    },
  },
};
</script>
 
<style lang="scss" scoped>
@import "../../../../css/abstracts/path";
@import "../../../../css/abstracts/colors";
@import "../../../../css/base/typography";
@import "../../../../css/base/utilities";
 
.document {
  width: 100%;
 
  .item {
    position: relative;
    padding: 1rem 0.75rem;
 
    .doc-title {
      margin: 0 0 2rem 0;
 
      @media (min-width: 768px) {
        margin: 0;
      }
 
      &.-has-eyebrow {
        position: relative;
 
        @extend %eyebrow-center;
      }
    }
 
    .tooltipper {
      position: relative;
 
      &:after {
        $size: 0.75rem;
        @include caret($size);
        border-bottom: $size solid $cc-resmed-white;
 
        left: 50%;
        margin-left: -0.75rem;
        top: 0.375rem;
      }
    }
 
    .tooltip {
      .content {
        border-radius: 6px;
        display: inline-block;
        min-width: 10rem;
 
        ul {
          list-style: none;
 
          li {
            a {
              margin: 0.2em 0;
              position: relative;
            }
          }
        }
      }
    }
  }
}
</style>